export const zIndex = {
  /** Above everything, modals included: the banner must stay reachable. */
  consent: '6',
  /** Above the cart drawer: a modal is the topmost thing on screen while it is open. */
  modal: '5',
  navigation: '4',
  cart: '4',
  cartOverlay: '3',
  header: '3',
  fixedCtaRow: '2',
};
